import styled from "styled-components";
import { designTokens } from "../../ui/foundation/DesignTokens";

// Mismos tokens y proporciones que SuscriptionAlert: las dos barras se apilan
// bajo el nav y deben leerse como la misma pieza.

// 360 y Meta pueden estar caídos a la vez, así que el contenedor apila. Es él
// quien ocupa el área del grid; las barras van dentro para no competir por la
// misma celda (dos elementos en un mismo grid-area se solapan).
export const Stack = styled.div`
  grid-area: incident;
  display: flex;
  flex-direction: column;
`;

export const Bar = styled.div`
  display: flex;
  column-gap: ${designTokens.spacing.lg};
  padding: 4px ${designTokens.spacing.xl};
  height: fit-content;
  z-index: 1;
  border: 1px solid ${designTokens.colors.gray[100]};
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: ${({ type }) =>
    type === "error" ? designTokens.colors.error[50] :
    type === "warning" ? designTokens.colors.warning[50] :
    "white"};
`;

export const MessageWrapper = styled.p`
  display: flex;
  gap: ${designTokens.spacing.sm};
  align-items: center;
  font-size: ${designTokens.fontSizes.sm};
  font-family: ${designTokens.fonts.body};
  color: ${({ type }) =>
    type === "error" ? designTokens.colors.error[600] :
    type === "warning" ? designTokens.colors.warning[600] :
    designTokens.colors.gray[900]};
`;
